import React from 'react';
import { Quote, Star } from 'lucide-react';
import { mockData } from '../utils/mock';

export const Testimonials = () => {
  return (
    <section className="relative py-24 bg-gradient-to-b from-zinc-900 to-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-orange-500/20 rounded-full mb-6">
            <Quote className="w-8 h-8 text-orange-500" />
          </div>
          <h2 className="text-4xl sm:text-5xl font-bold text-white mb-6">
            Testimonios Reales
          </h2>
          <p className="text-xl text-white/70 max-w-3xl mx-auto">
            Familias y futbolistas que han trabajado con Edgar Merino comparten su experiencia
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {mockData.testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="group relative p-8 bg-gradient-to-br from-zinc-900 to-black border border-white/10 rounded-2xl hover:border-orange-500/50 transition-all duration-300 hover:scale-105"
            >
              {/* Quote Icon */}
              <div className="absolute -top-4 -left-4 w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform duration-300">
                <Quote className="w-6 h-6 text-white" />
              </div>

              {/* Quote Text */}
              <div className="mb-6 mt-4">
                <p className="text-white/90 leading-relaxed italic">
                  "{testimonial.quote}"
                </p>
              </div>

              {/* Author Info */}
              <div className="pt-6 border-t border-white/10">
                <h4 className="text-white font-bold text-lg mb-1">
                  {testimonial.name}
                </h4>
                <p className="text-orange-500 font-semibold text-sm mb-2">
                  {testimonial.role}
                </p>
                <p className="text-white/60 text-xs leading-relaxed">
                  {testimonial.description}
                </p>
              </div>

              {/* Stars */}
              <div className="flex gap-1 mt-4">
                {[...Array(5)].map((_, i) => (
                  <Star
                    key={i}
                    className="w-4 h-4 text-orange-500 fill-orange-500"
                  />
                ))}
              </div>

              {/* Hover Accent */}
              <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-orange-500 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-b-2xl"></div>
            </div>
          ))}
        </div>

        {/* Trust Badge */}
        <div className="mt-16 text-center">
          <div className="inline-block p-6 bg-black/40 border border-orange-500/20 rounded-xl">
            <p className="text-white/80 text-sm mb-2">
              Experiencia comprobada con futbolistas de
            </p>
            <div className="flex flex-wrap justify-center gap-4 text-orange-500 font-semibold text-sm">
              <span>Liga F</span>
              <span className="text-white/30">•</span>
              <span>LaLiga</span>
              <span className="text-white/30">•</span>
              <span>Selecciones Nacionales</span>
              <span className="text-white/30">•</span>
              <span>Clubes Internacionales</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
